module.exports = __webpack_public_path__ + "img/messages-bubble-square-add.c7fb6d84.svg";